const cisAxiosConfig = {
  headers: {
    accept: 'application/familysearch-identity-result+v4.2+json',
    'content-type': 'application/familysearch-identity-result+v4.2+json',
  },
}

export default cisAxiosConfig
